import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-09/task-01";

const task: Slide = {
  titleHtml: `Four diffusers with different geometric profiles are shown below. Each diffuser profile starts<br>to create diffuse reflections above a certain frequency (“cut-off frequency”). Please drag and drop<br>the diffuser profiles in ascending order of cut-off frequency.`,
  description:
    "Drag and drop into correct order below in ascending order of frequency above which acoustic diffusion starts to occur.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
